/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Validation_Error_Modal_Subtitle_OtherInputs */

const en_validation_error_modal_subtitle_other = /** @type {(inputs: Validation_Error_Modal_Subtitle_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`There are ${i?.count} validation errors in the data grid.`)
};

const nl_validation_error_modal_subtitle_other = /** @type {(inputs: Validation_Error_Modal_Subtitle_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Er zijn ${i?.count} validatiefouten in het gegevensraster.`)
};

/**
* | output |
* | --- |
* | "There are {count} validation errors in the data grid." |
*
* @param {Validation_Error_Modal_Subtitle_OtherInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const validation_error_modal_subtitle_other = /** @type {((inputs: Validation_Error_Modal_Subtitle_OtherInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Error_Modal_Subtitle_OtherInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_validation_error_modal_subtitle_other(inputs)
	return en_validation_error_modal_subtitle_other(inputs)
});